import {
  GET_FORMATION_CATEGORIES,
  ADD_FORMATION_CATEGORY,
  EDIT_FORMATION_CATEGORY,
  DELETE_FORMATION_CATEGORY,
} from "../actions/formationCategory.actions";

const initialState = [];

export default function formationCategoryReducer(state = initialState, action) {
  switch (action.type) {
    case GET_FORMATION_CATEGORIES:
      return action.payload;
    case ADD_FORMATION_CATEGORY:
      if (state.some((c) => c.id === action.payload.id)) return state;
      return [...state, action.payload];
    case EDIT_FORMATION_CATEGORY:
      return state.map((c) => (c.id === action.payload.id ? action.payload : c));
    case DELETE_FORMATION_CATEGORY:
      return state.filter((c) => c.id !== action.payload.id);
    default:
      return state;
  }
}
